import { render } from "./NoahDuyurular.vue?vue&type=template&id=1ea4f3b2&scoped=true"
import script from "./NoahDuyurular.vue?vue&type=script&lang=js"
export * from "./NoahDuyurular.vue?vue&type=script&lang=js"

import "./NoahDuyurular.vue?vue&type=style&index=0&id=1ea4f3b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea4f3b2"]])

export default __exports__